<template>
  <m-card-item
    :icon="isOrphan ? 'warning-filled' : icon"
    :icon-color="isOrphan ? $colors.yellow.base : undefined"
    :tooltip="isOrphan ? $t('gridPageChart.deletedPropertyTooltip') : ''"
    tooltip-placement="left"
  >
    <slot />
    <template #right>
      <chart-editor-setting-value :value="displayValue" />
    </template>
  </m-card-item>
</template>

<script setup>
import ChartEditorSettingValue from '@/components/custom-grid/ChartEditorSettingValue.vue';

defineProps({
  icon: { type: String, required: true },
  displayValue: { type: [String, Number], default: '' },
  isOrphan: { type: Boolean, default: false },
});
</script>
